import React from 'react';
import { trackEventWithObject } from '@/utils/gaDataPush';
import useMediaQuery from '@/hooks/useMediaQuery';

function onSearchButtonClick() {
  const kingSearchInput = document.getElementById('king-search-input')! as any;
  const kingBtnSearch = kingSearchInput.closest('.king-btn-search')!;
  const kingHeaderUser = document.querySelector('.king-header-user')! as any;

  if (kingBtnSearch.classList.contains('king-btn-search-in')) {
    if (kingSearchInput.value) {
      (document as any).getElementById('king-search-form').submit();

      trackEventWithObject({
        event: 'header',
        general_event_category: 'Search',
        general_event_section: 'Search Submit',
        general_event_details: kingSearchInput.value || 'Undefined',
      });
    } else {
      kingBtnSearch.classList.remove('king-btn-search-in');
      kingHeaderUser.removeAttribute('style');
    }
  } else {
    kingBtnSearch.classList.add('king-btn-search-in');
    kingSearchInput.focus();
    trackEventWithObject({
      event: 'header',
      general_event_category: 'Search',
      general_event_section: 'Search Bar Click',
      general_event_details: 'Undefined',
    });
  }
}
function onSearchInputClick() {
  const kingSearchInput = document.getElementById('king-search-input')!;
  const kingBtnSearch = kingSearchInput.closest('.king-btn-search')!;

  kingBtnSearch.classList.add('king-btn-search-in');

  trackEventWithObject({
    event: 'header',
    general_event_category: 'Search',
    general_event_section: 'Search Bar Click',
    general_event_details: 'Undefined',
  });
}

export default function Search() {
  const isAboveDesktop = useMediaQuery('(min-width: 768px)');
  return (
    <div className="king-search">
      <form action="/search/" method="get" id={isAboveDesktop ? 'king-search-form' : 'desktop-search'}>
        <span id="king-search-wrap" className="king-btn-search">
          <input
            onClick={onSearchInputClick}
            id={isAboveDesktop ? 'king-search-input' : 'desktop-input'}
            className="inner-search-input placeholder searchspring-query"
            placeholder="Search"
            type="text"
            name="q"
            autoComplete="off"
            aria-label="Search"
            onKeyDown={e => {
              if (e.key === 'Enter') {
                onSearchButtonClick();
              }
            }}
            style={{ paddingRight: '35px' }}
          />
          <button
            onClick={onSearchButtonClick}
            type="button"
            className="iconfont iconfont-search"
            id="king-search-button"
            aria-label="Search"
            style={{ paddingLeft: '0px' }}
          />
        </span>
      </form>
    </div>
  );
}
